var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTableEdit = function SvgTableEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "table_edit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#table_edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.333 8.667h4V6h-4v2.667Zm0-4h9.334V3.333H3.333v1.334Zm0 9.333c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.26.392.575.392.941v4.2a2.494 2.494 0 0 0-1.333-.167c-.234.045-.459.12-.675.226a2.19 2.19 0 0 0-.592.425l-.65.65-3.417 3.4V14h-4Zm0-1.333h4V10h-4v2.667Zm5.334-4h2.083l.65-.65a2.19 2.19 0 0 1 .592-.425c.216-.106.441-.18.675-.225V6h-4v2.667Zm0 6v-2.05L12.35 8.95c.1-.1.211-.172.333-.217.123-.044.245-.066.367-.066a1.003 1.003 0 0 1 .717.3l.616.616c.09.1.159.211.209.334.05.122.075.244.075.366 0 .123-.023.248-.067.375a.894.894 0 0 1-.217.342l-3.666 3.667h-2.05Zm1-1h.633l2.017-2.034-.617-.616-2.033 2.016v.634Zm2.35-2.35-.317-.3.617.616-.3-.316Z",
    fill: "current"
  }))));
};
export default SvgTableEdit;